import React from 'react';
import './App.css';

class ShortcutKey extends React.Component {

  constructor(props) {
  	super(props);
  }

  render() {

  	let text = this.props.text;
  	let char = true;
  	if (text.length > 1) {
  		char = false;
  	}
  	return 	<div className={char ? "ShortcutKey" : "ShortcutKeyWide"}>
  				<div className="ShortcutKeyText">{this.props.text}</div>
  			</div>
  }

}

export default ShortcutKey;